module.exports = __webpack_public_path__ + "img/20191209_111923-1.98348d28.jpg";